import { AddressString } from '~components/providers/types';
import {
  BalFarm,
  BoostedFarm,
  ELPType,
  ENativeAsset,
  EOtherAsset,
  FarmTypes,
  FraxFarm,
  VestaFarm,
} from '~config/types';

import { ConfigFarm } from './types';

export const FARM_CONFIGURATION: { [index in FarmTypes | BoostedFarm]: ConfigFarm } = {
  [FraxFarm.VST_FRAX_GAUGE]: {
    lpToken: ELPType['VST-FRAX'],
    rewardToken: [EOtherAsset.FXS],
  },
  [BoostedFarm['VST-USDC']]: {
    lpToken: ELPType['VST-USDC'],
    rewardToken: [ENativeAsset.VSTA],
  },
  [VestaFarm['VST-FRAX']]: {
    lpToken: ELPType['VST-FRAX'],
    rewardToken: [EOtherAsset.FXS],
    end: 1645754400,
  },
  [VestaFarm['VSTA-ETH']]: {
    lpToken: ELPType['VSTA-ETH'],
    rewardToken: [ENativeAsset.VSTA],
    poolId: '0xc61ff48f94d801c1ceface0289085197b5ec44f000020000000000000000004d' as AddressString,
  },
  [BalFarm['VST-USDC-DAI-USDT']]: {
    lpToken: ELPType['VST-USDC-DAI-USDT'],
    rewardToken: [ELPType['VST-USDC-DAI-USDT']],
    deprecated: true,
    poolId: '0x5a5884fc31948d59df2aeccca143de900d49e1a300000000000000000000006f',
    poolName: 'VST-4Pool',
  },
  [BalFarm['V2-VST-USDC-DAI-USDT']]: {
    lpToken: ELPType['VST-USDC-DAI-USDT'],
    rewardToken: [ELPType['VST-USDC-DAI-USDT']],
    poolId: '0x7bceaa9c5e7f4836fec3bce2d5346637c9b13970000000000000000000000102',
    poolName: 'VST-4Pool',
  },
};
